export default {
  playerStates: [],
};
